// Session ID management for anonymous usage tracking

const SESSION_KEY = 'vibe-coach-session-id';

export const getSessionId = () => {
    let sessionId = localStorage.getItem(SESSION_KEY);
    if (!sessionId) {
        sessionId = `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
};

export const clearSessionId = () => {
    localStorage.removeItem(SESSION_KEY);
};
